<template>
  <div
      v-loading="isLoadingMessages"
      :class="['chat-content', { 'column-sender-open': columnSenderOpen }]"
  >
    <div v-if="questions.length > 1" :class="['points',!multiModel?'one':'']">
      <el-tooltip v-for="(q,qdx) in questions" :key="qdx" :content="q.content" effect="dark" placement="left">
        <div class="point" @click="anchor(q.id)">
          <div></div>
        </div>
      </el-tooltip>
    </div>
    <!-- 多栏模型才显示列标题，单栏隐藏 -->
    <div v-if="multiModel && modelInfo.name" class="column-title">
      <img :src="modelInfo.logo_url" alt="">
      <span>{{ modelInfo.name }}</span>
      <!-- 分享按钮：标题右边，打开父级统一管理的分享弹窗（携带本列模型 id） -->
      <SvgIcon
          v-if="chat_id > 0"
          :size="18"
          class="column-share-btn"
          color="rgb(139 139 139)"
          iconClass="action-btn"
          name="share"
          @click.native="$emit('share-click', { modelId: modelInfo.id })"
      />
    </div>
    <!--    无数据时的展示-->
    <div
        v-if="messages.length === 0&&!multiModel"
        class="chat-content-welcome"
    >
      <welcome @click-prompt="$emit('prompt-click', $event)"/>
    </div>
    <div v-if="chat_id>0&&!pager.complete" class="onLoadMore-class" @click="$emit('onLoadMore')">加载更多</div>
    <el-x-bubble-list
        ref="bubbleListRef"
        :defaultMaxWidth="'100%'"
        :list="messages"
        defaultShape="corner"
        max-height="none"
    >
      <template #avatar="{ item }">
        <el-avatar style="display: none"></el-avatar>
      </template>
      <template #header="{ item }">
        <div v-if="item.placement==='start'" class="model-name">
          <span>{{ item.model_info ? item.model_info.full_name : item.model_name }}</span>
          <span class="time">{{ item.created_at }}</span>
        </div>
        <bubble-list-header
            :item="item"
            :map-file-type="mapFileType"
            @update-workflow-active="handleUpdateWorkflowActive"
            @update-node-active="handleUpdateNodeActive"
        />
      </template>
      <!-- content slot: 用 bubble-content-padded 控制 padding，
            有内容时才渲染 padded div，空内容时不产生空白框 -->
      <template #content="{ item }">
        <!-- 流式响应尚未返回内容时的加载状态：三点动效 -->
        <div v-if="!item.content" class="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div v-if="item.content && item.placement === 'start'" class="bubble-content-padded">
          <el-x-typewriter
              v-if="item.content && item.placement === 'start'"
              :content="item.content"
              :md-plugins="mdPlugins"
              :typing="item.typing"
              is-markdown
          />
        </div>
        <div
            v-if="item.content && item.placement === 'end'"
            :id="`user-${modelInfo.name}-${item.id}`"
            class="bubble-content-padded"
        >
          <div class="user-content" style="white-space: pre-wrap">
            {{ item.content }}
          </div>
        </div>
        <div v-if="item.attachments && item.attachments.length" class="bubble-content-padded"
             style="display: flex;gap: 12px;">
          <div
              v-for="(el, edx) in item.attachments"
              :key="edx"
              class="file-card-wrapper"
              @click="handleFileClick(el)"
          >
            <el-x-files-card
                :img-variant="el.is_image=='1'?'square':'rectangle'"
                :name="el.name"
                :style-config="{
                  backgroundColor: '#f7f7f7',
                  border: '1px solid #eeeeee',
                  borderRadius: '8px',
                }"
                :url="el.url"
            />
          </div>
        </div>
      </template>
      <template #footer="{ item }">
        <bubble-list-footer
            :client_id="client_id"
            :dify-config="difyConfig"
            :item="item"
            :messages="messages"
            :robot="robot"
            @edit-message="$emit('edit-message', $event)"
            @retry-message="$emit('retry-message', $event)"
            @update-feedback="$emit('update-feedback', $event)"
        />
      </template>
    </el-x-bubble-list>
    <!-- 列内发送框：位于 bubble-list-footer 下方，固定在会话框底部，由选项卡按钮控制显隐 -->
    <div v-if="columnSenderOpen" class="column-sender">
      <el-x-sender
          :auto-size="{ minRows: 1, maxRows: 3 }"
          :value="senderValue"
          placeholder="发送单独的消息..."
          variant="updown"
          @input="senderValue = $event"
          @submit="handleColumnSubmit"
      />
    </div>
    <!--    多分栏暂时隐藏总结会话逻辑-->
    <!--    <div v-if="summary_status" class="summary">-->
    <!--      <span>需要帮你总结以上对话吗？</span>-->
    <!--      <div class="flex">-->
    <!--        <div class="summary-yes summary-no" @click="summaryTap(0)">否</div>-->
    <!--        <div class="summary-yes" @click="summaryTap(1)">是</div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!-- 建议问题区域 -->
    <!--    <div-->
    <!--        v-if="showSuggestedQuestions && suggestedQuestions.length > 0"-->
    <!--        class="suggested-questions"-->
    <!--    >-->
    <!--      <div class="suggested-title">建议问题：</div>-->
    <!--      <el-x-prompts-->
    <!--          :items="suggestedQuestions"-->
    <!--          :loading="isLoadingSuggestions"-->
    <!--          :styles="{-->
    <!--          justifyContent: 'center',-->
    <!--          item: {-->
    <!--            flex: 'none',-->
    <!--            backgroundImage: 'linear-gradient(137deg, #f0f7ff 0%, #edf1ff 100%)',-->
    <!--            border: '1px solid #e6efff',-->
    <!--            width: 'auto',-->
    <!--            minWidth: '200px',-->
    <!--            margin: '4px',-->
    <!--          },-->
    <!--        }"-->
    <!--          @on-item-click="handleSuggestedQuestionClick"-->
    <!--      >-->
    <!--        <template v-slot:icon="{ item }">-->
    <!--          <i-->
    <!--              :class="item.icon"-->
    <!--              :style="item.iconStyle"-->
    <!--          ></i>-->
    <!--        </template>-->
    <!--      </el-x-prompts>-->
    <!--    </div>-->
  </div>
</template>

<script>
import markdownItMermaidPlugin from '@/utils/markdownMermaidPlugin';
import 'katex/dist/katex.min.css';
import markdownItKatex from 'markdown-it-katex';
import BubbleListFooter from './BubbleListFooter.vue';
import BubbleListHeader from './BubbleListHeader.vue';
import Welcome from './Welcome.vue';

export default {
  name: 'ChatContent',
  computed: {},
  components: {
    BubbleListHeader,
    BubbleListFooter,
    Welcome,
  },
  props: {
    robot: {
      type: Object,
      default: () => ({}),
    },
    client_id: {},
    chat_id: {
      type: Number,
      default: 0
    },
    pager: {
      type: Object,
      default: () => ({}),
    },
    messages: {
      type: Array,
      default: () => [],
    },
    modelInfo: {
      type: Object,
      default: {},
    },
    multiModel: {
      type: Boolean,
      default: false,
    },
    // 列内发送框显隐（由 ChatContainer 的选项卡按钮控制）
    columnSenderOpen: {
      type: Boolean,
      default: false,
    },
    isLoadingMessages: {
      type: Boolean,
      default: false,
    },
    mapFileType: {
      type: Function,
      required: true,
    },
    difyConfig: {
      type: Object,
      required: true,
    },
    suggestedQuestions: {
      type: Array,
      default: () => [],
    },
    showSuggestedQuestions: {
      type: Boolean,
      default: false,
    },
    isLoadingSuggestions: {
      type: Boolean,
      default: false,
    },
    summary_status: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdPlugins: [markdownItMermaidPlugin, markdownItKatex],
      questions: [], //用户提问的问题列表};
      // 列内发送框输入内容
      senderValue: ''
    }
  },
  watch: {
    messages: {
      handler(val) {
        this.questions = val.filter(item => item.role === 'user')
      },
      deep: true
    },
    // 切换会话后清空列内发送框残留内容（组件按模型 id 复用，不会自动重置）
    chat_id() {
      this.senderValue = ''
    },
  },
  mounted() {
    this.questions = this.messages.filter(item => item.placement === 'end')
  },
  methods: {
    // 列内发送框提交：上报给父组件并清空本列输入
    handleColumnSubmit(message) {
      if (!message || !message.trim()) return
      this.$emit('column-send', {modelId: this.modelInfo.id, message})
      this.senderValue = ''
    },
    //锚点定位
    anchor(id) {
      let element = document.getElementById(`user-${this.modelInfo.name}-${id}`);
      element.scrollIntoView({behavior: 'smooth'});
    },
    // 处理文件点击事件，在新窗口打开预览
    handleFileClick(file) {
      if (file.url && file.is_image != '1') {
        if (['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'].includes(file.file_ext)) {
          window.open('https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(file.url), '_blank')
        } else {
          window.open(file.url, '_blank')
        }
      }
    },
    //总结
    summaryTap(e) {
      this.$emit('summary-click', e);
    },
    handleSuggestedQuestionClick(question) {
      this.$emit('suggested-question-click', question);
    },

    handleUpdateWorkflowActive(data) {
      this.$emit('update-workflow-active', data);
    },

    handleUpdateNodeActive(data) {
      this.$emit('update-node-active', data);
    },
  },
};
</script>

<style lang="scss" scoped>

.chat-content {
  display: flex;
  flex-direction: column;
  position: relative;

  // 列内发送框展开时：消息列表占满剩余空间并独立滚动，发送框固定在底部
  &.column-sender-open {
    ::v-deep .el-x-bubble-list {
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
    }
  }
}

// 列内发送框：固定在会话框底部
.column-sender {
  flex-shrink: 0;
  //border-top: 1px solid #e8e8e8;
  // 取消组件自带的提交箭头按钮
  ::v-deep .el-x-send-button {
    display: none;
  }

  ::v-deep .el-x-sender .el-x-sender-content[data-v-5824e87e] {
    padding-bottom: 12px;
  }

  ::v-deep .el-x-sender[data-v-5824e87e] {
    border-radius: 0 0 0.75rem 0.75rem;
  }

  // 列内发送框输入字号
  ::v-deep .el-x-sender-input .el-textarea__inner {
    line-height: 24px;
    font-size: 16px !important;
  }
}

.points {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  display: flex;
  flex-direction: column;
  z-index: 998;

  .point {
    padding: 6px 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    div {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: #7dcfff;
    }
  }
}

.points.one {
  position: fixed;
  right: 8px;
}

.chat-content-welcome {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .el-x-bubble-content-wrapper .el-x-bubble-content-filled {
  background: #F7F7F7 !important;
  border-radius: 16px 0 16px 16px !important;
  color: #333333 !important;
  padding: 0 !important;
  line-height: 20px !important;
}

// 气泡内边距由 slot 内的 .bubble-content-padded 控制：
// 有数据时该 div 渲染并提供 padding，空数据时不渲染→无空白框
.bubble-content-padded {
  padding: 0.5em;
}

// 加载中三点动效（等待流式首个 token 时展示）
.loading-dots {
  display: flex;
  align-items: center;
  gap: 5px;
  height: 20px; // 与一行文字等高，避免内容到达时气泡高度跳动
  padding: 0.5em;
  background: #ffffff !important;

  span {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #999999;
    animation: loading-dot 1.2s infinite ease-in-out;

    &:nth-child(2) {
      animation-delay: 0.15s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }
}

@keyframes loading-dot {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

::v-deep .el-x-bubble-start .el-x-bubble-content-wrapper .el-x-bubble-content-filled {
  border-radius: 0 16px 16px 16px !important;
}

::v-deep .el-x-bubble-end .el-x-bubble-content-wrapper .el-x-bubble-content-filled {
  border-radius: 16px 0 16px 16px !important;
  background: #e8f0fc !important;
}

::v-deep .markdown-body .highlight pre, ::v-deep .markdown-body pre {
  background: #f5f2f0 !important;
}

.onLoadMore-class {
  color: #4D79FF;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  padding-bottom: 8px;
}

.file-card-wrapper {
  cursor: pointer;
  display: inline-block;
}

.column-title {
  height: 36px;
  line-height: 36px;
  color: #303030;
  font-weight: bold;
  font-size: 14px;
  border-bottom: 1px solid #e8e8e8;
  flex-shrink: 0;
  display: flex;
  align-items: center;

  img {
    width: 16px;
    height: 16px;
    display: flex;
    margin: 0 8px;
    border-radius: 3px;
    object-fit: cover;
  }

  // 分享按钮：靠右显示
  .column-share-btn {
    margin-left: auto;
    margin-right: 12px;
    cursor: pointer;
    flex-shrink: 0;
  }
}

.chat-content {
  min-height: 100%;
  display: flex;
  flex-direction: column;

  .chat-content-welcome {
    width: 100%;
    margin: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .suggested-questions {
    margin-top: 16px;
    padding: 0 16px;

    .suggested-title {
      font-size: 14px;
      color: #666;
      margin-bottom: 8px;
      text-align: center;
    }
  }

  ::v-deep .el-x-bubble-list {
    gap: 0;

    .el-x-bubble.el-x-bubble-start {
      .el-x-bubble-content-wrapper {
        .el-x-bubble-header,
        .el-x-bubble-content:not(.el-x-bubble-content-loading) {
          width: 100%;
        }

        .el-x-bubble-footer {
          .end-action,
          .start-action {
            display: flex;
            gap: 10px;
            align-items: center;
            opacity: 1;
            transition: opacity 0.2s ease;

            .action-btn {
              cursor: pointer;
            }
          }
        }
      }

      // 鼠标悬停时显示footer
      //&:hover {
      //  .el-x-bubble-content-wrapper {
      //    .el-x-bubble-footer {
      //      .start-action {
      //        opacity: 1;
      //      }
      //    }
      //  }
      //}
    }

    .el-x-bubble.el-x-bubble-end {
      &:hover {
        .el-x-bubble-content-wrapper {
          .el-x-bubble-footer {
            .end-action {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.summary {
  background: rgba(250, 171, 12, 0.1);
  border-radius: 121px;
  border: 1px solid rgba(250, 171, 12, 0.2);
  padding: 0 16px;
  color: #FAAB0C;
  line-height: 38px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;

  .flex {
    display: flex;
    align-items: center;

    .summary-yes {
      width: 42px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      bbackground: rgba(250, 171, 12, 0.2);
      border-radius: 159px;
      cursor: pointer;
    }

    .summary-no {
      margin-right: 10px;
    }
  }
}


@media (max-width: 767px) {
  .chat-content {
    padding: 16px 0;

    .chat-content-welcome {
      padding: 0;
    }
  }
}

.model-name {
  line-height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .time {
    color: #a3a3a3;
  }
}
</style>
